import React, { useContext, useEffect } from "react";
import Layout from "../shared/Layout/Layout";
import PageIntro from "../shared/PageIntro/PageIntro";
import { objectiveContext } from "../../context/Objective";
import ComingSoon from "../shared/ComingSoon/ComingSoon";

// const data = [
//   {
//     id: 1,
//     NewsImage: "/assets/news1.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title: "Why Digital Twins Are Important For Commercial Real Estate?",
//     description:
//       "The IoT and machine learning have fostered a transformative technology called the digital twin. First used in the manufacturing sector, now it is widely adopted in real estate as it helps to building owners and managers to maintain buildings.It’s not a mere assertion. According to Mordor Intelligence report, the digital twin market will witness a CAGR of 35.0% over the forecast period 2019 - 2024...",
//   },
//   {
//     id: 2,
//     NewsImage: "/assets/news2.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title: "What is a digital twin?",
//     description:
//       "A digital twin is a digital replica of almost anything: places, people, processes, devices and, of course, physical assets. Let's take real estate as an example since it is the focus of our article. In this case, a digital twin contains a whole spectrum of data concerning the building itself Floor plans, Real-time sensor data from the building management system, Data from HVAC (heating, ventilation, and air-conditioning) system ,Security system...",
//   },
//   {
//     id: 3,
//     NewsImage: "/assets/news3.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title: "Why does real estate need technology?",
//     description:
//       "The desire for a digital replica of a building and its assets emerged from rather critical cases. During the design and construction stages, lots of valuable information is produced: documentation, drawings, notes A digital twin is the ultimate real-time database of the building ecosystem. Within hours, the building operators identify the area that needs reconfiguration and find the most cost-effective ways to do it...",
//   },
//   {
//     id: 4,
//     NewsImage: "/assets/news4.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title: "Digital twin benefits for the real estate",
//     description:
//       "Digital twin is the next stage of real estate innovation because of the benefits it brings, both immediate and long-term. It brings savings on maintenance costs, makes the building more sustainable, and raise the living standards of tenants.Speed up decision-making. Digital twin is a cloud solution allowing building owners and operators to access the virtual twin any time and make use of the statistics and predictive analytics...",
//   },
//   {
//     id: 5,
//     NewsImage: "/assets/news5.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title:
//       "Use of “Digital Twin” Modeling Could Transform Real Estate Industry",
//     description:
//       "real-time virtual models of objects, ranging from a building to an entire city—are an emerging concept that has the potential to transform the built environment and the real estate industry in numerous ways, according to the technology’s proponents. An Australian-based company that markets its trademarked WillowTwin digital twin platform globally.  “This data can be used for value creation, such as predictive analysis”...",
//   },
//   {
//     id: 6,
//     NewsImage: "/assets/news6.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title:
//       "Airport digital transformation from operational performance to strategic opportunity",
//     description:
//       "Today, airports are addressing increasingly complex operational challenges with exciting new business and technological innovation. Airports are undergoing massive transformation internally and digital tools are enabling new thinking as it relates to advertising, digital stores with interactive displays, loyalty programs and mobile applications for passengers...",
//   },
//   {
//     id: 7,
//     NewsImage: "/assets/news7.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title: "The digital transformation of video surveillance",
//     description:
//       "With demand for video solutions connected to the Internet growing, organisations are also adopting cloud-enabled platforms to generate benefits that go far beyond that of simple surveillance alone. Recent research carried out by Eagle Eye Networks underlines the point, with 63% of organisations participating in the Cloud Video Surveillance Camera2021 survey now using cloud-only recording...",
//   },
//   {
//     id: 8,
//     NewsImage: "/assets/news8.JPG",
//     date: "August 3, 2021",
//     role: "Admin",
//     title: "Digital twinning use cases strengthen with AR, VR",
//     description:
//       "Organizations can use the digital twin to optimize human operational processes, such as mapping how technicians walk through the data center. The infrastructure lead at a large financial services firm recently told Nemertes Research that the single most important initiative infrastructure engineers can engage in is implementing AR/VR and digital twinning in their infrastructure environments and automation testing...",
//   },
//   {
//     id: 9,
//     NewsImage: "/assets/news9.jpg",
//     date: "August 3, 2021",
//     role: "Admin",
//     title: "The Future Of Tech: Accelerated Digital Transformation",
//     description:
//       "Companies are in need of leaders who are truly digital and tech savvy; boards, CEO’s, and the C suite need to be ready to tackle the challenge of how to drive this compressed digital transformation in a shorter window of time. Many companies are now realizing perhaps their leadership team is not equipped with the skills needed to compete in a modern and rapidly shifting environment...",
//   },
// ];

function News() {
  useEffect(() => {
    document.title = "News - MetaWorldX";
  }, []);
  const { setSolutionActive, setCompanyActive } = useContext(objectiveContext);
  return (
    <Layout>
      <div
        onClick={() => {
          setCompanyActive(false);
          setSolutionActive(false);
        }}
        className="overflow-x-hidden mt-[60px]"
      >
        <>
          <PageIntro headingOne={"News"} headingTwo={"Home < News"} />
        </>

        <div className="flex justify-center items-center flex-col pt-14 pb-6 max-[481px]:pt-6">
          <ComingSoon />
        </div>
        <>
          <div className="relative w-full h-[90vh] max-[1200px]:h-[90vh] flex items-center flex-col justify-center bg-[url(/public/assets/home_bg.svg)] bg-cover bg-no-repeat bg-center">
            <img src="/assets/home_img.svg" alt="" />
          </div>
        </>

        {/* <div className="px-12 py-8 max-[481px]:px-4">
          <Row gutter={[50, 8]}>
            <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={8}>
              <NewSidebar />
            </Col>
            <Col xs={24} sm={24} md={24} lg={16} xl={16} xxl={16}>
              <Row gutter={[30, 30]}>
                {data.map((val) => (
                  <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={8}>
                    <Link to={`/news-details/${val.id}`}>
                      <NewsComp val={val} />
                    </Link>
                  </Col>
                ))}
              </Row>
              <div className="mt-[40px] flex justify-center items-center">
                <Pagination defaultCurrent={1} total={50} />
              </div>
            </Col>
          </Row>
        </div> */}
      </div>
    </Layout>
  );
}

export default News;
